module.exports = __webpack_public_path__ + "e89efbab1289646d8690532e188b9afc.fbx";